const NOC_ROOM_CATALOG = [
  { displayName: 'Piscina Camaronera El Morro', zone: 'Morro', codeHint: 'NOC-001' },
  { displayName: 'Piscina Estero Salado Norte', zone: 'Estero Norte', codeHint: 'NOC-002' },
  { displayName: 'Piscina Balao 7', zone: 'Balao', codeHint: 'NOC-003' },
  { displayName: 'Piscina Taura Delta', zone: 'Taura', codeHint: 'NOC-004' },
  { displayName: 'Piscina Chongon Alta', zone: 'Chongon', codeHint: 'NOC-005' },
  { displayName: 'Piscina Naranjal Este', zone: 'Naranjal', codeHint: 'NOC-006' },
  { displayName: 'Piscina Puerto Inca 3', zone: 'Puerto Inca', codeHint: 'NOC-007' },
  { displayName: 'Piscina Isla Puna Sur', zone: 'Puna', codeHint: 'NOC-008' },
  { displayName: 'Piscina Playas Oceano 2', zone: 'Playas', codeHint: 'NOC-009' },
  { displayName: 'Piscina Churute Central', zone: 'Churute', codeHint: 'NOC-010' },
  { displayName: 'Piscina Canal Jambeli 5', zone: 'Jambeli', codeHint: 'NOC-011' },
  { displayName: 'Piscina Posorja Bahia', zone: 'Posorja', codeHint: 'NOC-012' },
];

const ROOM_NAME_MAP = {
  'DEMO-001': NOC_ROOM_CATALOG[0],
  'DEMO-002': NOC_ROOM_CATALOG[1],
  'Demo-001': NOC_ROOM_CATALOG[0],
  'Demo-002': NOC_ROOM_CATALOG[1],
};

const createFallbackDemoData = (index) => {
  const profile = index % 4;

  if (profile === 0) {
    return { temp1: 27.2, temp2: 27.8, do1_mgL: 7.2, do2_mgL: 7.5 };
  }
  if (profile === 1) {
    return { temp1: 29.4, temp2: 29.8, do1_mgL: 5.8, do2_mgL: 6.1 };
  }
  if (profile === 2) {
    return { temp1: 24.9, temp2: 25.1, do1_mgL: 8.3, do2_mgL: 8.0 };
  }
  return { temp1: 31.2, temp2: 30.7, do1_mgL: 4.9, do2_mgL: 5.1 };
};

export const getRoomDisplayMeta = (code) => {
  if (ROOM_NAME_MAP[code]) return ROOM_NAME_MAP[code];

  const codeStr = String(code || '').trim();
  if (!codeStr) return { displayName: 'Piscina sin nombre', zone: 'Sin zona', codeHint: '-' };

  return {
    displayName: `Piscina ${codeStr}`,
    zone: 'Operacion Activa',
    codeHint: codeStr,
  };
};

export const buildNocRooms = (rooms) => {
  const rawRooms = Object.values(rooms).map((room, index) => {
    const meta = ROOM_NAME_MAP[room.code] || NOC_ROOM_CATALOG[index] || getRoomDisplayMeta(room.code);

    return {
      ...room,
      displayName: meta.displayName,
      zone: meta.zone,
      codeHint: room.code,
      isDemoCard: false,
    };
  });

  const dedupedRoomMap = new Map();
  rawRooms.forEach((room) => {
    const dedupeKey = String(room.displayName || room.code).trim().toLowerCase();
    const current = dedupedRoomMap.get(dedupeKey);

    if (!current) {
      dedupedRoomMap.set(dedupeKey, room);
      return;
    }

    const currentScore = (current.hasData ? 1000 : 0) + (current.lastUpdate ? new Date(current.lastUpdate).getTime() : 0);
    const candidateScore = (room.hasData ? 1000 : 0) + (room.lastUpdate ? new Date(room.lastUpdate).getTime() : 0);

    if (candidateScore >= currentScore) {
      dedupedRoomMap.set(dedupeKey, room);
    }
  });

  const realRooms = Array.from(dedupedRoomMap.values());

  const usedNames = new Set(realRooms.map((room) => room.displayName));
  const demoRooms = NOC_ROOM_CATALOG
    .filter((item) => !usedNames.has(item.displayName))
    .slice(0, Math.max(0, 12 - realRooms.length))
    .map((item, index) => ({
      code: `demo-card-${index + 1}`,
      displayName: item.displayName,
      zone: item.zone,
      codeHint: item.codeHint,
      hasData: false,
      isDemoCard: true,
      data: createFallbackDemoData(index),
      lastUpdate: null,
    }));

  const sortedRealRooms = [...realRooms].sort((a, b) => {
    if (a.hasData !== b.hasData) return a.hasData ? -1 : 1;
    return String(a.displayName || a.code).localeCompare(String(b.displayName || b.code), 'es');
  });

  return [...sortedRealRooms, ...demoRooms];
};
